import { TextService } from "../Services/TextService";
import { HistoryEventType } from "../Types/HistoryEventTypes";

export const mapHistoryEventTypeToText = (type: HistoryEventType) => {
    const GetText = TextService.GetText;

    switch (type) {
        case HistoryEventType.AddMember:
            return GetText("HistoryEvent_AddMember");
        case HistoryEventType.DeleteMember:
            return GetText("HistoryEvent_DeleteMember");
        case HistoryEventType.UpdatedMemberProperties:
            return GetText("HistoryEvent_UpdateMember");
        case HistoryEventType.UpdatedMemberPropertiesByMember:
            return GetText("HistoryEvent_UpdatedMemberByMember");
        case HistoryEventType.AddMemberByMember:
            return GetText("HistoryEvent_AddMemberByMember");
        case HistoryEventType.MemberIsActivated:
            return GetText("HistoryEvent_MemberActivated");
        case HistoryEventType.CreatedCustomListItem:
            return GetText("HistoryEvent_CreatedCustomListItem");
        case HistoryEventType.UpdatedCustomListItem:
            return GetText("HistoryEvent_UpdatedCustomListItem");
        case HistoryEventType.DeletedCustomListItem:
            return GetText("HistoryEvent_DeletedCustomListItem");
        case HistoryEventType.CustomListItemMemberConnectionChanged:
            return GetText("HistoryEvent_CustomListItemMemberConnectionChanged");
        case HistoryEventType.CreatedCustomListItemByMember:
            return GetText("HistoryEvent_CreatedCustomListItemByMember");
        case HistoryEventType.UpdatedCustomListItemByMember:
            return GetText("HistoryEvent_UpdatedCustomListItemByMember");
        case HistoryEventType.DeletedCustomListItemByMember:
            return GetText("HistoryEvent_DeletedCustomListItemByMember");
        case HistoryEventType.CustomListItemMemberConnectionChangedByMember:
            return GetText("HistoryEvent_CustomListItemMemberConnectionChangedByMember");
        default:
            return "Unknown";
    }
}